import {findAddedReference} from './buildCitationFromEvidence';
import {buildSupportingEvidenceRows} from './buildSupportingEvidenceRows';

/**
 * Count added references that support the claim (matches claim-item supporting badge).
 *
 * @param {Object|null|undefined} claim
 * @param {Array} [references]
 * @returns {number}
 */
export function getSupportingEvidenceCount(claim, references = []) {
    if (!claim) return 0;
    return buildSupportingEvidenceRows(claim, references)
        .filter((row) => findAddedReference(row.citation, references))
        .length;
}
